"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Tedavi süreci ne kadar sürer?",
  answer: "Gülüş tasarımı ve implant tedavilerimiz, hastamızın durumuna göre genellikle 3 ile 10 gün arasında tamamlanmaktadır. Dijital planlama süreçlerimiz sayesinde en kısa sürede kalıcı sonuçlar elde ediyoruz."
}, {
  question: "Tedavi sırasında ağrı hisseder miyim?",
  answer: "Tüm işlemlerimiz modern lokal anestezi teknikleri altında gerçekleştirilir. Hasta konforu en büyük önceliğimizdir, bu nedenle işlem sırasında herhangi bir ağrı veya sızı hissetmezsiniz."
}, {
  question: "Yurt dışından gelen hastalar için hangi hizmetleri sağlıyorsunuz?",
  answer: "Havalimanı VIP transfer, 5 yıldızlı otellerde konaklama organizasyonu ve tedavi sürecindeki tüm klinik ulaşımlarını içeren kapsamlı 'Dental Turizm' paketleri sunuyoruz."
}, {
  question: "Kullanılan malzemelerin kalitesi ve garantisi nedir?",
  answer: "Kliniğimizde yalnızca dünya çapında kabul görmüş, sertifikalı ve ömür boyu garanti seçenekleri sunan implant ve porselen materyalleri kullanılmaktadır. Her tedavi sonrası sertifikalarınız teslim edilir."
}, {
  question: "İlk muayene süreci nasıl ilerliyor?",
  answer: "Uzman hekimlerimiz tarafından gerçekleştirilen ilk muayene, panoramik röntgen çekimi ve 3D ağız içi tarama işlemleri, size en uygun tedavi planını oluşturmak amacıyla ücretsiz olarak sunulmaktadır."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169251" id="sık-sorulan-sorular" className="bg-secondary py-20 md:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 sm:px-6 max-w-[800px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight font-sans">
            Sık Sorulan Sorular
          </h2>
          <p className="text-foreground text-lg md:text-xl max-w-2xl mx-auto leading-relaxed opacity-80">
            Diş tedavilerimiz, süreçlerimiz ve hasta konforu hakkında en çok merak edilen detayları sizin için yanıtladık.
          </p>
        </div>

        <div className="w-full">
          <Accordion type="single" collapsible className="w-full space-y-0">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-primary/30 bg-transparent rounded-none px-0 data-[state=open]:border-primary data-[state=open]:border-b-2 transition-all duration-300 ease-in-out group overflow-hidden">
                <AccordionTrigger className="text-foreground font-medium font-sans text-lg md:text-xl hover:no-underline py-7 group-hover:text-primary transition-colors text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-foreground font-sans leading-loose text-base md:text-[1.05rem] pb-8 pt-2 opacity-90">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 flex flex-col items-center justify-center text-center space-y-6">
          <p className="text-xl font-medium text-foreground tracking-tight">
            Daha Fazla Bilgiye mi İhtiyacınız Var?
          </p>
          <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground border-2 h-14 px-10 rounded-full transition-all duration-300 ease-in-out shadow-sm hover:shadow-md text-base font-semibold">
            <Link to="/ContactPage">Uzmanlarımıza Danışın</Link>
          </Button>
        </div>
      </div>
    </section>;
}